class BackToTopButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('a');
    this.offset = parseInt(this.dataset.offset, 10) || 600;
    this.isScrolling = false;
  }

  connectedCallback() {
    if (!this.button) return;

    window.addEventListener('scroll', () => {
      if (!this.isScrolling) {
        window.requestAnimationFrame(() => {
          this.trackScroll();
          this.isScrolling = false;
        });
        this.isScrolling = true;
      }
    }, { passive: true });

    this.button.addEventListener('click', this.scrollToTop.bind(this));
    
    // Comprobación inmediata al cargar
    this.trackScroll();
  }

  trackScroll() {
    const scrolled = window.scrollY;
    // Añadimos 'show' solo si superamos el offset
    if (scrolled > this.offset) {
      this.classList.add('show');
      this.removeAttribute('aria-hidden');
    } else {
      this.classList.remove('show');
      this.setAttribute('aria-hidden', 'true');
    }
  }

  scrollToTop(event) {
    event.preventDefault();
    
    // Lógica de Scroll Suave (Smooth Interpolation)
    const duration = 800; 
    const start = window.scrollY;
    const startTime = performance.now();

    const easeInOutCubic = (t) => {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    };

    const animateScroll = (currentTime) => {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);

      window.scrollTo(0, start * (1 - ease));

      if (timeElapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }
}

if (!customElements.get('back-to-top-button')) {
  customElements.define('back-to-top-button', BackToTopButton);
}